// src/components/UnitConverterCard.ts
import "./UnitConverterCard.css";

export function renderUnitConverterCard(
  container: HTMLElement,
  query: string,
): void {
  const match = query.match(/([\d.]+)\s*(\w+)\s*to\s*(\w+)/i);

  if (!match) {
    container.innerHTML = `
      <div class="card-container unit-card">
        <div class="unit-error">Try: "10 km to miles"</div>
      </div>
    `;
    return;
  }

  const value = parseFloat(match[1]);
  const from = match[2].toLowerCase();
  const to = match[3].toLowerCase();

  const conversions: Record<string, number> = {
    km: 1,
    miles: 0.621371,
  };

  if (!(from in conversions) || !(to in conversions)) {
    container.innerHTML = `
      <div class="card-container unit-card">
        <div class="unit-error">Unsupported units.</div>
      </div>
    `;
    return;
  }

  const result = (value * (conversions[to] / conversions[from])).toFixed(3);

  container.innerHTML = `
    <div class="card-container unit-card">
      <div class="unit-line">
        <span class="unit-value">${value} ${from}</span>
        <span class="unit-arrow">→</span>
        <span class="unit-result">${result} ${to}</span>
      </div>
    </div>
  `;
}
